import { render, staticRenderFns } from "./OrderShippingEstimations.vue?vue&type=template&id=77f8d1f5&"
import script from "./OrderShippingEstimations.vue?vue&type=script&lang=js&"
export * from "./OrderShippingEstimations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports